import { StaticQuery, graphql } from "gatsby";
import React from "react";

import {
  Section,
  Image,
  Card,
  Header2,
  Underlined,
  Paragraph,
} from "@racepointenergy/gatsby-theme-sitespark/src/components/Hero";
import { getSize } from "@racepointenergy/gatsby-theme-sitespark/src/components/Theme/utils";

export const DistributedEnergyResourceManagement = () => (
  <Section>
    <StaticQuery
      query={graphql`
        query MeterImageQuery {
          file(relativePath: { eq: "meter.png" }) {
            ...HeroImage
          }
        }
      `}
      render={({ file }) => (
        <Image
          alt=""
          css={`
            + picture > img,
            img {
              object-position: 70% 50%;
              @media screen and (min-width: ${getSize("tablet720")}) {
                object-position: 50% 50%;
              }
            }
          `}
          file={file}
        />
      )}
    />

    <Card
      css={`
        @media screen and (min-width: ${getSize(
            "tablet720"
          )}) and (max-width: 959px) {
          width: 500px;
          padding: 41px 46px 43px 46px;
        }
        @media screen and (min-width: ${getSize(
            "desktop1200"
          )}) and (max-width: 1919px) {
          width: 536px;
          padding: 41px 46px 50px 46px;
        }
        @media screen and (min-width: ${getSize("desktop1920")}) {
          padding: 76px 80px 70px 80px;
          width: 640px;
        }
      `}
    >
      <Header2>
        {"Distributed Energy Resource Management"}
        <Underlined />
      </Header2>
      <Paragraph>
        More intelligent system balancing helps utilities make the most of their
        existing energy assets. Savant Power’s Flexible Load Management provides
        near instantaneous load control where it is needed. Providing utilities
        with an effective tool for managing power quality, mitigating congestion
        and deferring costly infrastructure upgrades.
      </Paragraph>
    </Card>
  </Section>
);
